import React from "react";
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {Login, AuthGState} from "@leap4/frontend";
import {RootState} from "../../../interfaces/root-state.interface";
import {
    BACKEND_SERVICE_NAME,
    setCookieUrl,
    requiredAuthRoles,
    meMultiUrl,
    loginUrl
} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";

const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    auth: AuthGState;
}


const LoginContainer = ({auth}: IProps) => {

    const user = auth.user;
    return <Login {...{user, redirectUrlForAuthenticated: urlService.organizations(), setCookieUrl, loginUrl}}
                  serviceName={BACKEND_SERVICE_NAME}
                  meUrl={meMultiUrl}
                  requiredRoles={requiredAuthRoles}
                  dashboardName={"XPM Dashboard"}
    />;
}


export default connector(LoginContainer)
